import {View} from "./View"

export const PaymentMethodsLink = () => {
    return (
        <View/>
    )
}
